export enum RolesCollection {
  DocsUpload = 'OPC_DOCS_UPLOAD',
  OrdersViewOnly = 'OPC_SALES_VIEW',
  MultipleOrders = 'OPC_MUL_ORD',
  DemandSchedule = 'OPC_DEM_SCH',
  CreateJobsiteModificationRequests = 'CI_JSM_CREATE',
  CreateOrdersGeneral = 'OPC_CUST_OWNER',
  CommercialConditions = 'QCMBUYER',
  CommercialConditionsAgreements = 'QCMAGREEMENTS_VIEW',
  ProjectProductsView = 'PJM_PROJECTPRODUCTS_VIEW',
  ProjectProductsEdit = 'PJM_PROJECTPRODUCTS_EDIT',
  SalesRepresentative = 'OPC_SALESREP',
  SalesView = 'OPC_SALES_VIEW',
  CreatePodRequests = 'CI_CUST_PODREQ',
  ShowPricesRms = 'OPC_SHOW_PRICES_RMS',
}
